import React from 'react';
import useLog from '../../../../services/log/hooks/useLog';
import LogTable from '../../../pms-log/components/LogTable';
import FormSpinner from '../../../../shared/components/spinner/FormSpinner';

interface ReservationLogHistoryTabProps {
    /** The booking_room id of the reservation currently open. */
    bookingId: string;
}

const columns = [
    { label: 'Date', key: 'created_at' },
    { label: 'User', key: 'user.name' },
    { label: 'Action', key: 'action' },
    { label: 'Detail', key: 'log' },
];

/**
 * "Log History" tab in the reservation detail drawer — every Create/Update/
 * Delete action recorded against THIS booking_room id (create/update/cancel/
 * move/switch/split/merge/status/comment), filtered server-side via
 * LogController@index's booking_room_id filter so both historical
 * model_type variants are covered.
 */
const ReservationLogHistoryTab: React.FC<ReservationLogHistoryTabProps> = ({ bookingId }) => {
    const { data: logData, isFetching } = useLog({
        include: 'user',
        filters: { booking_room_id: bookingId, all: 1 },
    });

    if (isFetching) {
        return <FormSpinner />;
    }

    if (!logData || logData.data.length === 0) {
        return <div className="text-center text-muted py-4">No activity recorded yet for this reservation.</div>;
    }

    return <LogTable data={logData} columns={columns} />;
};

export default ReservationLogHistoryTab;
